module.exports = __webpack_public_path__ + "img/analytic_reports.png";